const FileManager = () =>
  import(
    /* webpackChunkName: "cms-file-and-documents" */ '@/pages/cms/file-and-documents/index.vue'
  )
const FileManagerEdit = () =>
  import(
    /* webpackChunkName: "cms-file-and-documents" */ '@/pages/cms/file-and-documents/media.vue'
  )

export default {
  path: 'file-and-documents',
  meta: {
    label: 'doc',
    auth: 'doc'
  },
  component: {
    name: 'CmsDocument',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CmsFileAndDocuments',
      path: '',
      meta: {
        label: 'fileAndDocuments',
        auth: 'root'
      },
      component: FileManager
    },
    {
      name: 'CmsEditFileAndDocuments',
      path: ':root',
      meta: {
        label: 'edit',
        auth: 'root'
      },
      props: true,
      component: FileManagerEdit
    }
  ]
}
